module.exports = __webpack_public_path__ + "static/media/20110524_4521.47ab7d73.jpg";